import { useUserAccount } from '@/api/user';
import BalanceButton from '@/components/BalanceButton';
import LanguageButton from '@/components/LanguageModal/LanguageButton';
import NotificationButton from '@/components/Notifications/NotificationButton';
import { UserRankCard } from '@/components/UserRankCard';
import useLayoutSettings from '@/hooks/theme/useLayoutSettings';
import { useResolvedTheme } from '@/hooks/theme/useResolvedTheme';
import { useIsMobile } from '@starsoft/common/hooks';
import { Setting, SettingLayoutComponentId } from '@starsoft/common/models';
import { ComponentTypeId } from '@starsoft/common/models/setting/layout/component/type/types.enum';
import styles from './styles.module.scss';

export default function HeaderCommonButtons({ setting }: { setting: Setting }) {
  const { components } = useResolvedTheme(setting);
  const { isAuthorized } = useUserAccount();
  const { isV4LayoutVariant } = useLayoutSettings();
  const userPlayerId =
    components.get(ComponentTypeId.UserProfileChip?.toString())?.toString() ??
    SettingLayoutComponentId.UserProfileChipV1?.toString();
  const isMobile = useIsMobile();
  if (!isAuthorized) {
    return null;
  }

  return (
    <>
      <div className={styles.content__desktop__only}>
        {!isV4LayoutVariant && <NotificationButton />}
        <LanguageButton />
      </div>
      {isAuthorized && isV4LayoutVariant && <BalanceButton />}
      {(!isV4LayoutVariant || (isV4LayoutVariant && !isMobile)) && (
        <UserRankCard id={userPlayerId} />
      )}
      {isV4LayoutVariant && <NotificationButton />}
    </>
  );
}
